import { Stack } from "@mui/material"
import React from 'react'

export const FormActions = ({ children }) => <Stack direction={{ xs: 'column-reverse', md: 'row' }} gap='1rem'
  mt={{ xs: '2rem', md: '3rem' }}
>
  {children}
</Stack>